module.exports = __webpack_public_path__ + "img/n11.d2489d6d.png";